<div class="domainselect" id="hoverOnLeftPanel">
  <select id="dropDownForDomainsSection" name="recordList" class="select-wrapper"  (change)="onDomainChange($event)" [disabled]="changeDropdownView()">
      <ng-container *ngFor="let domains of userDomains">
    <option [selected]="domains.id == selectedDomain" [value]="domains.id">{{domains.name}}</option>
    
  </ng-container>
  </select>
</div>
<ul class="menuContent">

<ng-container *ngFor="let button of buttons">
  <li *ngIf="button.enable" [class]="button.class" id="{{button.class}}Link" routerLinkActive="{{button.router_link ? 'active': ''}}" [routerLink]="button.router_link ? button.router_link: ''">
    <i [class]="button.alternateClass" [id]="button.alternateClass"></i>
    <span [id]="button.alternateClass+'id' | lowercase" [innerHTML]="button.name"></span>
  </li>
</ng-container>
</ul>
<div class="userProfile">
<div class="userName spImg">
  <span class="shortname">
    <ng-container *ngIf="profileImageUrl && (profileImageUrl !== '')">
      <img [src]="profileImageUrl">
    </ng-container>
    <ng-container *ngIf="!profileImageUrl || (profileImageUrl === '')">
      {{inits}}
    </ng-container>
  </span>
  <span id="userNameLabelAfterLogin" class="displayname">
    {{name}}
    <span class="userrole">[{{role | titlecase}}]</span>
  </span>
  <div class="userprofileBlock">
    <ul class="profileOption">
      <li class="logout"><a href="/login"> <i class="icon-logout"></i><span id="singOutButton">Logout</span></a></li>
    </ul>
  </div>
</div>
</div>